import { render, staticRenderFns } from "./NowhowTextline.vue?vue&type=template&id=48a70f70"
import script from "./NowhowTextline.vue?vue&type=script&lang=ts"
export * from "./NowhowTextline.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports